import axiosInstance from "./axiosInstance";
import { showAlertError, showAlertExito } from '../utils/alertHelper';

const odontologia = 'odontologia';
const consultorio = 'consultorio';

// Listar consultorios
export const listConsultorios = async () => {
    try {
        const response = await axiosInstance.get(`/${odontologia}/${consultorio}/list`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema al listar consultorios.");
    }
};

// Crear consultorio
export const createConsultorio = async (data) => {
    try {
        const response = await axiosInstance.post(`/${odontologia}/${consultorio}/create`, data);
        showAlertExito("¡Éxito!", "Consultorio creado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "No se pudo crear el consultorio.");
    }
};

// Actualizar consultorio
export const updateConsultorio = async (id, data) => {
    try {
        const response = await axiosInstance.put(`/${odontologia}/${consultorio}/edit/${id}`, data);
        showAlertExito("¡Éxito!", "Consultorio actualizado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "No se pudo actualizar el consultorio.");
    }
};

// Actualizar consultorio (sin alertas UI) para procesos en background
export const updateConsultorioSilent = async (id, data) => {
    try {
        const response = await axiosInstance.put(`/${odontologia}/${consultorio}/edit/${id}`, data);
        return response.data;
    } catch (error) {
        console.warn("Fallo silencioso al actualizar consultorio", error);
    }
};

const servicio = 'servicio';

// Listar servicios
export const listServicios = async () => {
    try {
        const response = await axiosInstance.get(`/${odontologia}/${servicio}/list`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema al listar servicios.");
    }
};

// Crear servicio
export const createServicio = async (data) => {
    try {
        const response = await axiosInstance.post(`/${odontologia}/${servicio}/create`, data);
        showAlertExito("¡Éxito!", "Servicio creado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "No se pudo crear el servicio.");
    }
};

// Actualizar servicio
export const updateServicio = async (id, data) => {
    try {
        const response = await axiosInstance.put(`/${odontologia}/${servicio}/edit/${id}`, data);
        showAlertExito("¡Éxito!", "Servicio actualizado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "No se pudo actualizar el servicio.");
    }
};

const tratamiento = 'tratamiento';

// Listar tratamientos
export const listTratamientos = async () => {
    try {
        const response = await axiosInstance.get(`/${odontologia}/${tratamiento}/list`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema al listar tratamientos.");
    }
};

// Crear tratamiento
export const createTratamiento = async (data) => {
    try {
        const response = await axiosInstance.post(`/${odontologia}/${tratamiento}/create`, data);
        showAlertExito("¡Éxito!", "Tratamiento creado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "No se pudo crear el tratamiento.");
    }
};

// Actualizar tratamiento
export const updateTratamiento = async (id, data) => {
    try {
        const response = await axiosInstance.put(`/${odontologia}/${tratamiento}/edit/${id}`, data);
        showAlertExito("¡Éxito!", "Tratamiento actualizado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "No se pudo actualizar el tratamiento.");
    }
};

const citas = 'citas';

// Listar citas lazy (paginado)
export const listCitasLazy = async (page, limit, buscar) => {
    try {
        const response = await axiosInstance.get(`/${odontologia}/${citas}/lazy/${page}/${limit}/${buscar}`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema al cargar las citas.");
    }
};

// Listar citas
export const listCitas = async () => {
    try {
        const response = await axiosInstance.get(`/${odontologia}/${citas}/list`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema al listar citas.");
    }
};

// Listar citas por fecha (vista diaria)
export const listCitasByFecha = async (fecha) => {
    try {
        const response = await axiosInstance.get(`/${odontologia}/${citas}/list/fecha/${fecha}`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema al cargar las citas del día.");
    }
};

// Crear cita
export const createCita = async (data) => {
    try {
        const response = await axiosInstance.post(`/${odontologia}/${citas}/create`, data);
        showAlertExito("¡Éxito!", "Cita programada exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "No se pudo crear la cita.");
    }
};

// Actualizar cita
export const updateCita = async (id, data) => {
    try {
        const response = await axiosInstance.put(`/${odontologia}/${citas}/edit/${id}`, data);
        showAlertExito("¡Éxito!", "Cita actualizada exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "No se pudo actualizar la cita.");
    }
};

// Listar citas activas (programadas/confirmadas)
export const listCitasActivas = async () => {
    try {
        const response = await axiosInstance.get(`/${odontologia}/${citas}/list/activas`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema al listar citas activas.");
    }
};

// Listar tratamientos por receptor
export const listTratamientosByReceptor = async (id_receptor) => {
    try {
        const response = await axiosInstance.get(`/${odontologia}/${tratamiento}/receptor/${id_receptor}`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "No se pudieron cargar los tratamientos del paciente.");
    }
};

const tipoTratamiento = 'tipo-tratamiento';

// Listar tipos de tratamiento
export const listTiposTratamiento = async () => {
    try {
        const response = await axiosInstance.get(`/${odontologia}/${tipoTratamiento}/list`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema al listar los tipos de tratamiento.");
    }
};

// Crear tipo de tratamiento
export const createTipoTratamiento = async (data) => {
    try {
        const response = await axiosInstance.post(`/${odontologia}/${tipoTratamiento}/create`, data);
        showAlertExito("¡Éxito!", "Tipo de tratamiento creado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "No se pudo crear el tipo de tratamiento.");
    }
};

// Actualizar tipo de tratamiento
export const updateTipoTratamiento = async (id, data) => {
    try {
        const response = await axiosInstance.put(`/${odontologia}/${tipoTratamiento}/edit/${id}`, data);
        showAlertExito("¡Éxito!", "Tipo de tratamiento actualizado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "No se pudo actualizar el tipo de tratamiento.");
    }
};

const horarioGeneral = 'horario-general';

// Listar horarios generales
export const listHorariosGenerales = async () => {
    try {
        const response = await axiosInstance.get(`/${odontologia}/${horarioGeneral}/list`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema al listar el horario general.");
    }
};

// Crear horario general
export const createHorarioGeneral = async (data) => {
    try {
        const response = await axiosInstance.post(`/${odontologia}/${horarioGeneral}/create`, data);
        showAlertExito("¡Éxito!", "Horario creado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "No se pudo crear el horario.");
    }
};

// Actualizar horario general
export const updateHorarioGeneral = async (id, data) => {
    try {
        const response = await axiosInstance.put(`/${odontologia}/${horarioGeneral}/edit/${id}`, data);
        showAlertExito("¡Éxito!", "Horario actualizado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "No se pudo actualizar el horario.");
    }
};

const medico = 'medico';

// Listar médicos odontología
export const listMedicos = async () => {
    try {
        const response = await axiosInstance.get(`/${odontologia}/${medico}/list`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema al listar los médicos.");
    }
};

// Crear médico odontología
export const createMedico = async (data) => {
    try {
        const response = await axiosInstance.post(`/${odontologia}/${medico}/create`, data);
        showAlertExito("¡Éxito!", "Médico registrado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "No se pudo registrar el médico.");
    }
};

// Actualizar médico odontología
export const updateMedico = async (id, data) => {
    try {
        const response = await axiosInstance.put(`/${odontologia}/${medico}/edit/${id}`, data);
        showAlertExito("¡Éxito!", "Médico actualizado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "No se pudo actualizar el médico.");
    }
};

const configuracion = 'configuracion';

// Listar configuración
export const listConfiguracion = async () => {
    try {
        const response = await axiosInstance.get(`/${odontologia}/${configuracion}`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema al obtener la configuración.");
    }
};

// Crear configuración
export const createConfiguracion = async (data) => {
    try {
        const response = await axiosInstance.post(`/${odontologia}/${configuracion}/create`, data);
        showAlertExito("¡Éxito!", "Configuración creada exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "No se pudo crear la configuración.");
    }
};

// Actualizar configuración
export const updateConfiguracion = async (id, data) => {
    try {
        const response = await axiosInstance.put(`/${odontologia}/${configuracion}/edit/${id}`, data);
        showAlertExito("¡Éxito!", "Configuración actualizada exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "No se pudo actualizar la configuración.");
    }
};
